import { render, staticRenderFns } from "./RoleScopeModal.vue?vue&type=template&id=a27158c6&scoped=true&"
import script from "./RoleScopeModal.vue?vue&type=script&lang=js&"
export * from "./RoleScopeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27158c6",
  null
  
)

export default component.exports